import {isEmpty} from 'lodash-es';

const defaultHeroImages = Object.keys(
	import.meta.glob('~/public/images/motion/default/*.@(jpg|png)', {
		eager: true,
	}),
);

export default {
	inheritAttrs: true,
	methods: {
		shuffle(array) {
			const shuffleArray = array;
			for (let i = shuffleArray.length - 1; i > 0; i -= 1) {
				const j = Math.floor(Math.random() * (i + 1));
				[shuffleArray[i], shuffleArray[j]] = [shuffleArray[j], shuffleArray[i]];
			}
			return shuffleArray;
		},
		componentName(name) {
			let templateName = name;
			if (!templateName) return '';
			templateName = templateName.toString();
			templateName =
				templateName.charAt(0).toUpperCase() + templateName.slice(1);
			return `Nk${templateName}`;
		},
	},

	computed: {
		defaultHeroImages() {
			if (defaultHeroImages.length) {
				let shuffledDefaultHeroImages = this.shuffle(defaultHeroImages);

				if (shuffledDefaultHeroImages.length > 5)
					shuffledDefaultHeroImages = shuffledDefaultHeroImages.slice(0, 5);

				return shuffledDefaultHeroImages.map(
					// eslint-disable-next-line no-useless-escape
					image => `motion/default/${image.replace(/^.*[\\\/]/, '')}`,
				);
			}
			return false;
		},
		shuffledHeroImages() {
			if (this.page?.heroImages.length) {
				let shuffledHeroImages = this.shuffle(this.page.heroImages);

				if (shuffledHeroImages.length > 5)
					shuffledHeroImages = shuffledHeroImages.slice(0, 5);

				return shuffledHeroImages;
			}

			return false;
		},
		emptySidebar() {
			const filterContext = this.page.context.filter(module => {
				let hasContext = true;

				if (module.slotName === 'sidebar') {
					if (typeof module.context === 'object' && isEmpty(module.context)) {
						hasContext = false;
					}

					if (Array.isArray(module.context) && module.context.length === 0) {
						hasContext = false;
					}

					if (typeof module.context === 'string' && module.context === '') {
						hasContext = false;
					}
					// slotName is null or "content"
				} else {
					hasContext = false;
				}

				return hasContext;
			});

			return filterContext.length === 0;
		},
	},
};
